import React, { useEffect } from 'react';
import { setSelectedInternship } from 'actions/selectedInternshipActions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import InternshipSwitcherContainer from 'pages/Applicant/InternshipSwitcherContainer';
import { refreshIframe } from 'actions/iframeActions';
import { Main, FooterWrapper } from './LayoutStyled';
import Header from './Header';

const Layout = ({
  children,
  refreshIframe,
  setSelectedInternship,
  history,
}) => {
  const pathArray = history.location.pathname.split('/');
  const selectedInternshipId = pathArray[2] ? +pathArray[2] : null;
  // Login-Award-Redesign (Etappe D): der /login-Screen ist ein Vollbild-Split
  // ohne App-Chrome. Header, Internship-Switcher und Footer werden dort unter-
  // drueckt, der Main verliert sein Padding (LoginStage bricht full-bleed aus).
  const hideChrome = history.location.pathname === '/login';
  useEffect(() => {
    setSelectedInternship({ pk: selectedInternshipId });
  }, [setSelectedInternship, selectedInternshipId]);
  return (
    <>
      {!hideChrome && <Header />}
      <Main hideChrome={hideChrome}>
        <>
          {!hideChrome && <InternshipSwitcherContainer />}
          {children}
        </>
      </Main>
      {!hideChrome && <FooterWrapper updateIframe={() => refreshIframe()} />}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  refreshIframe: PropTypes.func.isRequired,
  setSelectedInternship: PropTypes.func.isRequired,
  history: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

export default connect(
  null,
  { refreshIframe, setSelectedInternship },
)(withRouter(Layout));
